import PropTypes from 'prop-types'
import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import styles from './DetailRow.module.scss'

const propTypes = {
  /**
   * Message id of the label (or plain string if size="sm")
   */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  /**
   * Detail value
   */
  value: PropTypes.node.isRequired,
  /**
   * Column size for the label (applies to sm/md/lg). If provided, overrides the size-based defaults.
   */
  labelSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * Column size for the value (applies to sm/md/lg). If provided, overrides the size-based defaults.
   */
  valueSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * Size variant: "sm" (small, PropertyField-style), "md" (medium, default), or "lg" (large)
   */
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
}

const defaultProps = {
  labelSize: undefined,
  valueSize: undefined,
  size: 'md',
}

const SIZE_CONFIG = {
  sm: {
    labelSize: '4',
    valueSize: '8',
    rowClass: [styles.row, styles.sm],
    useFormattedMessage: false,
    showColon: false,
    emptyValueDisplay: 'None',
  },
  md: {
    labelSize: 3,
    valueSize: 7,
    rowClass: [styles.row],
    useFormattedMessage: true,
    showColon: true,
    emptyValueDisplay: null,
  },
  lg: {
    labelSize: 3,
    valueSize: 7,
    rowClass: [styles.row],
    useFormattedMessage: true,
    showColon: true,
    emptyValueDisplay: null,
  },
}

function DetailRow(props) {
  const { label, value, size } = props
  const { labelSize, valueSize } = props

  const config = SIZE_CONFIG[size] || SIZE_CONFIG.md
  const hasValue = value !== null && value !== undefined && value !== '' && value !== false
  const displayValue = hasValue ? value : config.emptyValueDisplay

  const labelColProps = {
    sm: labelSize !== undefined ? labelSize : config.labelSize,
    md: labelSize !== undefined ? labelSize : config.labelSize,
    lg: labelSize !== undefined ? labelSize : config.labelSize,
  }

  const valueColProps = {
    sm: valueSize !== undefined ? valueSize : config.valueSize,
    md: valueSize !== undefined ? valueSize : config.valueSize,
    lg: valueSize !== undefined ? valueSize : config.valueSize,
  }

  const rowClassName = config.rowClass.filter(Boolean).join(' ')
  const valueClassName =
    size === 'sm' ? `${styles.value} ${hasValue ? 'text-color-default' : 'text-color-secondary'}`.trim() : styles.value

  return (
    <Row className={rowClassName}>
      <Col {...labelColProps}>
        <p className={`text-bold text-color-secondary ${styles.label}`}>
          {config.useFormattedMessage ? label && <FormattedMessage id={label} /> : label}
          {config.showColon && ':'}
        </p>
      </Col>
      <Col {...valueColProps}>
        <div className={valueClassName}>
          {displayValue !== null ? (
            displayValue
          ) : (
            <span className="text-color-secondary">
              <FormattedMessage id="GENERAL.NONE" />
            </span>
          )}
        </div>
      </Col>
    </Row>
  )
}

DetailRow.propTypes = propTypes
DetailRow.defaultProps = defaultProps

export default DetailRow
